import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import { useIntl } from 'react-intl';
import { IconCodeSecondary } from '@/icons';
import { Textarea } from '@/ui/Textarea/Textarea';
import { css } from 'styled-components';
import HorizontalDivider from '@/ui/HorizontalDivider';
import { ActionCustomCodeNodeType } from '../../Nodes/types';
import FAQSection from '../FAQSection';
import { StyledSettings, StyledSettingsContent } from '../styles';
import { GeneralSettingsType } from '../types';

function CustomCodeSettings({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  settings,
  selectedNode,
  updateNodeData,
  disabled,
}: {
  settings: GeneralSettingsType;
  selectedNode: ActionCustomCodeNodeType;
  updateNodeData: (id: string, newData: any) => void;
  disabled?: boolean;
}) {
  const intl = useIntl();

  const faqs = [
    {
      question: intl.formatMessage({
        defaultMessage: 'What is Custom Code?',
        id: 'y9U4BL',
      }),
      answer: intl.formatMessage({
        defaultMessage:
          'Custom Code allows you to execute your own sdk code within the logic editor. For documentation please consult the development team.',
        id: '5zebdf',
      }),
    },
  ];
  const relevantData = selectedNode.data.options;

  return (
    <StyledSettings data-testid="action-customCode-settings">
      <Flex align="center" gap={8}>
        <IconCodeSecondary />
        <Flex direction="column">
          <T h3>
            {intl.formatMessage({
              defaultMessage: 'Custom Code',
              id: 'fQ4nKo',
            })}
          </T>
        </Flex>
      </Flex>
      <StyledSettingsContent>
        <Flex direction="column" gap={8}>
          <T body1>
            {intl.formatMessage({
              defaultMessage: 'Custom Code',
              id: 'fQ4nKo',
            })}
          </T>

          <Textarea
            disabled={disabled ?? false}
            value={relevantData.customCode}
            onChange={(e) =>
              updateNodeData(selectedNode.id, {
                ...selectedNode.data,
                options: {
                  ...relevantData,
                  customCode: e.target.value,
                  // customCode: "Luc don't even try it",
                },
              })
            }
            placeholder={intl.formatMessage({
              defaultMessage: 'Enter your custom code here...',
              id: 'Lb9mWP',
            })}
            styles={css`
              height: 200px;
              overflow: auto;
              resize: vertical;
            `}
            required
          />
        </Flex>
        <HorizontalDivider />
      </StyledSettingsContent>
      <FAQSection faqs={faqs} />
    </StyledSettings>
  );
}
export default CustomCodeSettings;
